import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export var TOPIC_ICON_IDS = [{
  icon_id: 'clima'
}, {
  icon_id: 'desempeno'
}, {
  icon_id: 'learning'
}, {
  icon_id: 'fire'
}, {
  icon_id: 'arrowRandom'
}];
export var adaptToTopicHanaChipWidget = function adaptToTopicHanaChipWidget(categories) {
  return categories.map(function (category, index) {
    return _objectSpread(_objectSpread({}, category), {}, {
      name: category.name || '',
      copilot_prompts: category.copilot_prompts.map(function (prompt) {
        return _objectSpread(_objectSpread({}, prompt), {}, {
          name: prompt.name || '',
          description: prompt.description || null,
          template: prompt.template ? _objectSpread(_objectSpread({}, prompt.template), {}, {
            name: prompt.template.name || '',
            prompt: prompt.template.prompt || '',
            suggested_prompt: prompt.template.suggested_prompt.map(function (sp) {
              return {
                id: sp.id,
                name: sp.name || '',
                prompt: sp.prompt || ''
              };
            })
          }) : null
        });
      })
    }, index < TOPIC_ICON_IDS.length ? TOPIC_ICON_IDS[index] : {});
  });
};
export var adaptEndUserCategories = function adaptEndUserCategories(categories) {
  return categories.map(function (category, index) {
    var _TOPIC_ICON_IDS$index;
    return {
      id: category.id,
      name: category.name || '',
      description: category.description || null,
      icon_id: category.icon_id || ((_TOPIC_ICON_IDS$index = TOPIC_ICON_IDS[index]) === null || _TOPIC_ICON_IDS$index === void 0 ? void 0 : _TOPIC_ICON_IDS$index.icon_id),
      copilot_prompts: category.copilot_prompts.map(function (prompt) {
        return {
          id: prompt.id,
          name: prompt.name || '',
          description: prompt.description || null,
          template: prompt.template ? {
            id: prompt.template.id,
            name: prompt.template.name || '',
            prompt: prompt.template.prompt,
            suggested_prompt: []
          } : null
        };
      })
    };
  });
};